import logo from "../../assets/logoCopie.png";

const LegalNotice = () => {
  document.title = "Dev'Alls - Mentions légales & CGU";
  return (
    <>
      <main className="mainLegales">
        <section className="sectionLegale">
          <div className="retourFleche">
            <p>
              <a className="retour" href="/devalls">
                <span className="returnHome">{"<"}</span> Retour
              </a>
            </p>
          </div>
          <div className="containLogo">
            <a className="navbar-brand" href="/devalls">
              <img src={logo} className="logo_mentions" alt="logo" />
            </a>
          </div>
          <div className="divLegales">
            <h1 className="h1Mentions">📜 Mentions Légales</h1>
            <section className="legalNotice">
              <div id="editor" className="sectionMention">
                <h2 className="h2Mentions">Éditeur du site</h2>
                <div className="pMentions">
                  <p>
                    Nom de l’agence : <strong>Dev'Alls</strong>
                  </p>
                  <p>
                    Forme juridique : <strong>Auto-entreprise</strong>
                  </p>
                  <p>
                    Numéro SIRET / SIREN : <strong>939 239 653</strong>
                  </p>
                  <p>
                    Adresse :{" "}
                    <strong>
                      7 Résidence des fougères, 76560 Héricourt-En-Caux
                    </strong>
                  </p>
                  <p>
                    Email :{" "}
                    <a
                      href="mailto:contact@example.com"
                      className="linkContact linkMention"
                    >
                      contact.devalls@gmail.com
                    </a>
                  </p>
                  <p>
                    Téléphone :{" "}
                    <a
                      className="linkContact linkMention"
                      href="tel:+33770349718"
                    >
                      07 70 34 97 18
                    </a>
                  </p>
                </div>
              </div>
              <div id="hebergement" className="sectionMention">
                <h2 className="h2Mentions">Hébergement</h2>
                <div className="pMentions">
                  <p>
                    <strong>Hébergement du site web (Frontend) :</strong> Vercel
                  </p>
                  <p>Adresse : 340 S Lemon Ave #4133, Walnut, CA 91789, USA</p>
                  <p>
                    Site web :{" "}
                    <a
                      href="https://vercel.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="linkContact linkMention"
                    >
                      https://vercel.com
                    </a>
                  </p>

                  <p>
                    <strong>Hébergement du backend :</strong> Heroku
                  </p>
                  <p>
                    Adresse : Salesforce Tower, 415 Mission Street, San
                    Francisco, CA 94105, USA
                  </p>
                  <p>
                    Site web :{" "}
                    <a
                      href="https://www.heroku.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="linkContact linkMention"
                    >
                      https://www.heroku.com
                    </a>
                  </p>

                  <p>
                    <strong>Nom de domaine enregistré chez :</strong> Namecheap
                  </p>
                  <p>
                    Adresse : 4600 East Washington Street, Suite 305, Phoenix,
                    AZ 85034, USA
                  </p>
                  <p>
                    Site web :{" "}
                    <a
                      href="https://www.namecheap.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="linkContact linkMention"
                    >
                      https://www.namecheap.com
                    </a>
                  </p>
                </div>
              </div>
              <div id="propriety" className="sectionMention">
                <h2 className="h2Mentions">Propriété intellectuelle</h2>
                <div className="pMentions">
                  <p className="proprietyP">
                    L’ensemble des contenus présents sur ce site (textes,
                    images, logos, code source, design) est protégé par le droit
                    d’auteur et la propriété intellectuelle. Toute reproduction,
                    distribution ou modification sans autorisation préalable est
                    interdite.
                  </p>
                </div>
              </div>
              <div id="responsability" className="sectionMention">
                <h2 className="h2Mentions">Responsabilité</h2>
                <div className="pMentions">
                  <p className="proprietyP">
                    Dev'Alls met tout en œuvre pour assurer l’exactitude et la
                    mise à jour des informations présentes sur son site.
                    Cependant, elle ne peut être tenue responsable d’éventuelles
                    erreurs, interruptions ou dommages résultant de
                    l’utilisation du site.
                  </p>
                </div>
                <div id="data" className="sectionMention">
                  <h2 className="h2Mentions">Données personnelles & Cookies</h2>
                  <div className="pMentions">
                    <p className="proprietyP">
                      Dev'Alls collecte certaines données personnelles via des
                      formulaires (contact, devis…). Ces données ne sont jamais
                      revendues et sont uniquement utilisées dans le cadre de la
                      relation client. Le site utilise des cookies pour
                      améliorer l’expérience utilisateur. Vous pouvez gérer vos
                      préférences via notre{" "}
                      <a
                        className="linkContact linkMention"
                        href="/privacypolicy"
                      >
                        Politique de Confidentialité
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="divLegales">
            <h1 className="h1Mentions">
              📑 Conditions Générales d’Utilisation (CGU)
            </h1>
            <section className="legalNotice">
              <div id="editor" className="sectionMention">
                <h2 className="h2Mentions">1. Objet</h2>
                <div className="pMentions">
                  <p>
                    Les présentes Conditions Générales d’Utilisation ont pour
                    objet de définir les règles d’accès et d’utilisation du site
                    Dev'Alls ainsi que les droits et responsabilités de
                    l’éditeur et des utilisateurs.
                  </p>
                </div>
              </div>
              <div id="object" className="sectionMention">
                <h2 className="h2Mentions">2. Accès au site et aux services</h2>
                <div className="pMentions">
                  <p>
                    Le site est accessible gratuitement à tout utilisateur
                    disposant d’un accès à Internet. Dev'Alls propose des
                    services de création de sites web, e-commerce, applications
                    mobiles et logiciels pour les particuliers et les
                    professionnels.
                  </p>
                </div>
              </div>
              <div id="accesWeb" className="sectionMention">
                <h2 className="h2Mentions">3. Responsabilités</h2>
                <div className="pMentions">
                  <p className="proprietyP">
                    L’utilisateur s’engage à utiliser le site conformément aux
                    lois en vigueur. Dev'Alls ne pourra être tenue responsable
                    en cas de :
                  </p>
                  <ul className="ulMentions">
                    <li>
                      - Problèmes techniques entraînant l’interruption du site.
                    </li>
                    <li>
                      - Contenus extérieurs accessibles via des liens
                      hypertextes.
                    </li>
                    <li>- Mauvaise utilisation du site par l’utilisateur.</li>
                  </ul>
                </div>
              </div>
              <div id="responsability" className="sectionMention">
                <h2 className="h2Mentions">4. Propriété intellectuelle</h2>
                <div className="pMentions">
                  <p className="proprietyP">
                    Les éléments du site (contenus, images, logos, codes)
                    restent la propriété exclusive de Dev'Alls. Toute
                    reproduction, modification ou diffusion sans autorisation
                    est interdite.
                  </p>
                </div>
                <div id="property" className="sectionMention">
                  <h2 className="h2Mentions">
                    5. Protection des données personnelles
                  </h2>
                  <div className="pMentions">
                    <p className="proprietyP">
                      Conformément au RGPD, l’utilisateur dispose d’un droit
                      d’accès, de rectification et de suppression de ses données
                      personnelles en écrivant à {""}
                      <a
                        className="linkContact linkMention"
                        href="mailto:contact.devalls@gmail.com"
                      >
                        contact.devalls@gmail.com
                      </a>
                      .
                    </p>
                  </div>
                </div>
                <div id="modify" className="sectionMention">
                  <h2 className="h2Mentions">6. Modification des CGU</h2>
                  <div className="pMentions">
                    <p className="proprietyP">
                      Dev'Alls se réserve le droit de modifier les présentes CGU
                      à tout moment. Les utilisateurs sont invités à les
                      consulter régulièrement.
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </main>
    </>
  );
};

export default LegalNotice;
